import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import './RegisterPage.css';

const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan',              dial: '+93'   },
  { code: 'AL', name: 'Albanie',                  dial: '+355'  },
  { code: 'DZ', name: 'Algérie',                  dial: '+213'  },
  { code: 'AD', name: 'Andorre',                  dial: '+376'  },
  { code: 'AO', name: 'Angola',                   dial: '+244'  },
  { code: 'AG', name: 'Antigua-et-Barbuda',       dial: '+1268' },
  { code: 'AR', name: 'Argentine',                dial: '+54'   },
  { code: 'AM', name: 'Arménie',                  dial: '+374'  },
  { code: 'AU', name: 'Australie',                dial: '+61'   },
  { code: 'AT', name: 'Autriche',                 dial: '+43'   },
  { code: 'AZ', name: 'Azerbaïdjan',              dial: '+994'  },
  { code: 'BS', name: 'Bahamas',                  dial: '+1242' },
  { code: 'BH', name: 'Bahreïn',                  dial: '+973'  },
  { code: 'BD', name: 'Bangladesh',               dial: '+880'  },
  { code: 'BB', name: 'Barbade',                  dial: '+1246' },
  { code: 'BY', name: 'Biélorussie',              dial: '+375'  },
  { code: 'BE', name: 'Belgique',                 dial: '+32'   },
  { code: 'BZ', name: 'Belize',                   dial: '+501'  },
  { code: 'BJ', name: 'Bénin',                    dial: '+229'  },
  { code: 'BT', name: 'Bhoutan',                  dial: '+975'  },
  { code: 'BO', name: 'Bolivie',                  dial: '+591'  },
  { code: 'BA', name: 'Bosnie-Herzégovine',       dial: '+387'  },
  { code: 'BW', name: 'Botswana',                 dial: '+267'  },
  { code: 'BR', name: 'Brésil',                   dial: '+55'   },
  { code: 'BN', name: 'Brunei',                   dial: '+673'  },
  { code: 'BG', name: 'Bulgarie',                 dial: '+359'  },
  { code: 'BF', name: 'Burkina Faso',             dial: '+226'  },
  { code: 'BI', name: 'Burundi',                  dial: '+257'  },
  { code: 'CV', name: 'Cap-Vert',                 dial: '+238'  },
  { code: 'KH', name: 'Cambodge',                 dial: '+855'  },
  { code: 'CM', name: 'Cameroun',                 dial: '+237'  },
  { code: 'CA', name: 'Canada',                   dial: '+1'    },
  { code: 'CF', name: 'Centrafrique',             dial: '+236'  },
  { code: 'TD', name: 'Tchad',                    dial: '+235'  },
  { code: 'CL', name: 'Chili',                    dial: '+56'   },
  { code: 'CN', name: 'Chine',                    dial: '+86'   },
  { code: 'CO', name: 'Colombie',                 dial: '+57'   },
  { code: 'KM', name: 'Comores',                  dial: '+269'  },
  { code: 'CG', name: 'Congo',                    dial: '+242'  },
  { code: 'CD', name: 'Congo RDC',                dial: '+243'  },
  { code: 'CR', name: 'Costa Rica',               dial: '+506'  },
  { code: 'HR', name: 'Croatie',                  dial: '+385'  },
  { code: 'CU', name: 'Cuba',                     dial: '+53'   },
  { code: 'CY', name: 'Chypre',                   dial: '+357'  },
  { code: 'CZ', name: 'Tchéquie',                 dial: '+420'  },
  { code: 'DK', name: 'Danemark',                 dial: '+45'   },
  { code: 'DJ', name: 'Djibouti',                 dial: '+253'  },
  { code: 'DM', name: 'Dominique',                dial: '+1767' },
  { code: 'DO', name: 'Rép. dominicaine',         dial: '+1809' },
  { code: 'EC', name: 'Équateur',                 dial: '+593'  },
  { code: 'EG', name: 'Égypte',                   dial: '+20'   },
  { code: 'SV', name: 'Salvador',                 dial: '+503'  },
  { code: 'GQ', name: 'Guinée équatoriale',       dial: '+240'  },
  { code: 'ER', name: 'Érythrée',                 dial: '+291'  },
  { code: 'EE', name: 'Estonie',                  dial: '+372'  },
  { code: 'SZ', name: 'Eswatini',                 dial: '+268'  },
  { code: 'ET', name: 'Éthiopie',                 dial: '+251'  },
  { code: 'FJ', name: 'Fidji',                    dial: '+679'  },
  { code: 'FI', name: 'Finlande',                 dial: '+358'  },
  { code: 'FR', name: 'France',                   dial: '+33'   },
  { code: 'GA', name: 'Gabon',                    dial: '+241'  },
  { code: 'GM', name: 'Gambie',                   dial: '+220'  },
  { code: 'GE', name: 'Géorgie',                  dial: '+995'  },
  { code: 'DE', name: 'Allemagne',                dial: '+49'   },
  { code: 'GH', name: 'Ghana',                    dial: '+233'  },
  { code: 'GR', name: 'Grèce',                    dial: '+30'   },
  { code: 'GD', name: 'Grenade',                  dial: '+1473' },
  { code: 'GT', name: 'Guatemala',                dial: '+502'  },
  { code: 'GN', name: 'Guinée',                   dial: '+224'  },
  { code: 'GW', name: 'Guinée-Bissau',            dial: '+245'  },
  { code: 'GY', name: 'Guyana',                   dial: '+592'  },
  { code: 'HT', name: 'Haïti',                    dial: '+509'  },
  { code: 'HN', name: 'Honduras',                 dial: '+504'  },
  { code: 'HU', name: 'Hongrie',                  dial: '+36'   },
  { code: 'IS', name: 'Islande',                  dial: '+354'  },
  { code: 'IN', name: 'Inde',                     dial: '+91'   },
  { code: 'ID', name: 'Indonésie',                dial: '+62'   },
  { code: 'IR', name: 'Iran',                     dial: '+98'   },
  { code: 'IQ', name: 'Irak',                     dial: '+964'  },
  { code: 'IE', name: 'Irlande',                  dial: '+353'  },
  { code: 'IL', name: 'Israël',                   dial: '+972'  },
  { code: 'IT', name: 'Italie',                   dial: '+39'   },
  { code: 'JM', name: 'Jamaïque',                 dial: '+1876' },
  { code: 'JP', name: 'Japon',                    dial: '+81'   },
  { code: 'JO', name: 'Jordanie',                 dial: '+962'  },
  { code: 'KZ', name: 'Kazakhstan',               dial: '+7'    },
  { code: 'KE', name: 'Kenya',                    dial: '+254'  },
  { code: 'KI', name: 'Kiribati',                 dial: '+686'  },
  { code: 'KP', name: 'Corée du Nord',            dial: '+850'  },
  { code: 'KR', name: 'Corée du Sud',             dial: '+82'   },
  { code: 'KW', name: 'Koweït',                   dial: '+965'  },
  { code: 'KG', name: 'Kirghizistan',             dial: '+996'  },
  { code: 'LA', name: 'Laos',                     dial: '+856'  },
  { code: 'LV', name: 'Lettonie',                 dial: '+371'  },
  { code: 'LB', name: 'Liban',                    dial: '+961'  },
  { code: 'LS', name: 'Lesotho',                  dial: '+266'  },
  { code: 'LR', name: 'Libéria',                  dial: '+231'  },
  { code: 'LY', name: 'Libye',                    dial: '+218'  },
  { code: 'LI', name: 'Liechtenstein',            dial: '+423'  },
  { code: 'LT', name: 'Lituanie',                 dial: '+370'  },
  { code: 'LU', name: 'Luxembourg',               dial: '+352'  },
  { code: 'MG', name: 'Madagascar',               dial: '+261'  },
  { code: 'MW', name: 'Malawi',                   dial: '+265'  },
  { code: 'MY', name: 'Malaisie',                 dial: '+60'   },
  { code: 'MV', name: 'Maldives',                 dial: '+960'  },
  { code: 'ML', name: 'Mali',                     dial: '+223'  },
  { code: 'MT', name: 'Malte',                    dial: '+356'  },
  { code: 'MH', name: 'Îles Marshall',            dial: '+692'  },
  { code: 'MR', name: 'Mauritanie',               dial: '+222'  },
  { code: 'MU', name: 'Maurice',                  dial: '+230'  },
  { code: 'MX', name: 'Mexique',                  dial: '+52'   },
  { code: 'FM', name: 'Micronésie',               dial: '+691'  },
  { code: 'MD', name: 'Moldavie',                 dial: '+373'  },
  { code: 'MC', name: 'Monaco',                   dial: '+377'  },
  { code: 'MN', name: 'Mongolie',                 dial: '+976'  },
  { code: 'ME', name: 'Monténégro',               dial: '+382'  },
  { code: 'MA', name: 'Maroc',                    dial: '+212'  },
  { code: 'MZ', name: 'Mozambique',               dial: '+258'  },
  { code: 'MM', name: 'Myanmar',                  dial: '+95'   },
  { code: 'NA', name: 'Namibie',                  dial: '+264'  },
  { code: 'NR', name: 'Nauru',                    dial: '+674'  },
  { code: 'NP', name: 'Népal',                    dial: '+977'  },
  { code: 'NL', name: 'Pays-Bas',                 dial: '+31'   },
  { code: 'NZ', name: 'Nouvelle-Zélande',         dial: '+64'   },
  { code: 'NI', name: 'Nicaragua',                dial: '+505'  },
  { code: 'NE', name: 'Niger',                    dial: '+227'  },
  { code: 'NG', name: 'Nigeria',                  dial: '+234'  },
  { code: 'MK', name: 'Macédoine du Nord',        dial: '+389'  },
  { code: 'NO', name: 'Norvège',                  dial: '+47'   },
  { code: 'OM', name: 'Oman',                     dial: '+968'  },
  { code: 'PK', name: 'Pakistan',                 dial: '+92'   },
  { code: 'PW', name: 'Palaos',                   dial: '+680'  },
  { code: 'PA', name: 'Panama',                   dial: '+507'  },
  { code: 'PG', name: 'Papouasie-Nouvelle-Guinée',dial: '+675'  },
  { code: 'PY', name: 'Paraguay',                 dial: '+595'  },
  { code: 'PE', name: 'Pérou',                    dial: '+51'   },
  { code: 'PH', name: 'Philippines',              dial: '+63'   },
  { code: 'PL', name: 'Pologne',                  dial: '+48'   },
  { code: 'PT', name: 'Portugal',                 dial: '+351'  },
  { code: 'QA', name: 'Qatar',                    dial: '+974'  },
  { code: 'RO', name: 'Roumanie',                 dial: '+40'   },
  { code: 'RU', name: 'Russie',                   dial: '+7'    },
  { code: 'RW', name: 'Rwanda',                   dial: '+250'  },
  { code: 'KN', name: 'Saint-Kitts-et-Nevis',     dial: '+1869' },
  { code: 'LC', name: 'Sainte-Lucie',             dial: '+1758' },
  { code: 'VC', name: 'Saint-Vincent',            dial: '+1784' },
  { code: 'WS', name: 'Samoa',                    dial: '+685'  },
  { code: 'SM', name: 'Saint-Marin',              dial: '+378'  },
  { code: 'ST', name: 'Sao Tomé-et-Principe',     dial: '+239'  },
  { code: 'SA', name: 'Arabie saoudite',          dial: '+966'  },
  { code: 'SN', name: 'Sénégal',                  dial: '+221'  },
  { code: 'RS', name: 'Serbie',                   dial: '+381'  },
  { code: 'SC', name: 'Seychelles',               dial: '+248'  },
  { code: 'SL', name: 'Sierra Leone',             dial: '+232'  },
  { code: 'SG', name: 'Singapour',                dial: '+65'   },
  { code: 'SK', name: 'Slovaquie',                dial: '+421'  },
  { code: 'SI', name: 'Slovénie',                 dial: '+386'  },
  { code: 'SB', name: 'Îles Salomon',             dial: '+677'  },
  { code: 'SO', name: 'Somalie',                  dial: '+252'  },
  { code: 'ZA', name: 'Afrique du Sud',           dial: '+27'   },
  { code: 'SS', name: 'Soudan du Sud',            dial: '+211'  },
  { code: 'ES', name: 'Espagne',                  dial: '+34'   },
  { code: 'LK', name: 'Sri Lanka',                dial: '+94'   },
  { code: 'SD', name: 'Soudan',                   dial: '+249'  },
  { code: 'SR', name: 'Suriname',                 dial: '+597'  },
  { code: 'SE', name: 'Suède',                    dial: '+46'   },
  { code: 'CH', name: 'Suisse',                   dial: '+41'   },
  { code: 'SY', name: 'Syrie',                    dial: '+963'  },
  { code: 'TW', name: 'Taïwan',                   dial: '+886'  },
  { code: 'TJ', name: 'Tadjikistan',              dial: '+992'  },
  { code: 'TZ', name: 'Tanzanie',                 dial: '+255'  },
  { code: 'TH', name: 'Thaïlande',               dial: '+66'   },
  { code: 'TL', name: 'Timor oriental',           dial: '+670'  },
  { code: 'TG', name: 'Togo',                     dial: '+228'  },
  { code: 'TO', name: 'Tonga',                    dial: '+676'  },
  { code: 'TT', name: 'Trinité-et-Tobago',        dial: '+1868' },
  { code: 'TN', name: 'Tunisie',                  dial: '+216'  },
  { code: 'TR', name: 'Turquie',                  dial: '+90'   },
  { code: 'TM', name: 'Turkménistan',             dial: '+993'  },
  { code: 'TV', name: 'Tuvalu',                   dial: '+688'  },
  { code: 'UG', name: 'Ouganda',                  dial: '+256'  },
  { code: 'UA', name: 'Ukraine',                  dial: '+380'  },
  { code: 'AE', name: 'Émirats arabes unis',      dial: '+971'  },
  { code: 'GB', name: 'Royaume-Uni',              dial: '+44'   },
  { code: 'US', name: 'États-Unis',               dial: '+1'    },
  { code: 'UY', name: 'Uruguay',                  dial: '+598'  },
  { code: 'UZ', name: 'Ouzbékistan',              dial: '+998'  },
  { code: 'VU', name: 'Vanuatu',                  dial: '+678'  },
  { code: 'VE', name: 'Venezuela',                dial: '+58'   },
  { code: 'VN', name: 'Viêt Nam',                 dial: '+84'   },
  { code: 'YE', name: 'Yémen',                    dial: '+967'  },
  { code: 'ZM', name: 'Zambie',                   dial: '+260'  },
  { code: 'ZW', name: 'Zimbabwe',                 dial: '+263'  },
  { code: 'CI', name: "Côte d'Ivoire",            dial: '+225'  },
];

function FlagImg({ code, size = 20 }) {
  return (
    <img
      src={`https://flagcdn.com/w40/${code.toLowerCase()}.png`}
      alt={code}
      width={size}
      height={size * 0.67}
      style={{ borderRadius: 3, objectFit: 'cover', display: 'block', flexShrink: 0 }}
      onError={(e) => { e.target.style.display = 'none'; }}
    />
  );
}

export default function RegisterPage() {
  const navigate = useNavigate();
  const { register, login } = useAuth();
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get('ref') ?? '';

  const [form, setForm] = useState({
    email: '',
    username: '',
    phone: '',
    country: 'CD',
    password: '',
    confirm: '',
    referralCode: refCode,
    terms: false,
  });

  const [showPw,      setShowPw]      = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [countryOpen, setCountryOpen] = useState(false);
  const [countrySearch, setCountrySearch] = useState('');
  const [errors,      setErrors]      = useState({});
  const [submitError, setSubmitError] = useState('');
  const [submitting,  setSubmitting]  = useState(false);

  const selectedCountry = COUNTRIES.find(c => c.code === form.country) || COUNTRIES[0];

  /* ── Password strength ── */
  const pwStrength = (() => {
    const p = form.password;
    if (!p) return 0;
    let s = 0;
    if (p.length >= 8)          s++;
    if (/[A-Z]/.test(p))        s++;
    if (/[0-9]/.test(p))        s++;
    if (/[^A-Za-z0-9]/.test(p)) s++;
    return s;
  })();
  const strengthLabels = ['', 'Faible', 'Moyen', 'Bon', 'Fort'];
  const strengthColors = ['', '#e53935', '#ff9800', '#ffc107', '#1db954'];

  /* ── Field setter ── */
  const set = (field, val) => {
    setForm(f => ({ ...f, [field]: val }));
    setErrors(e => ({ ...e, [field]: null }));
  };

  /* ── Validation ── */
  const validate = () => {
    const e = {};
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email))
      e.email = 'Email invalide';
    if (!form.username.trim() || form.username.trim().length < 3)
      e.username = "Nom d'utilisateur requis (min 3 caractères)";
    if (!form.phone.trim())
      e.phone = 'Numéro de téléphone requis';
    if (form.password.length < 8)
      e.password = 'Minimum 8 caractères';
    if (form.password !== form.confirm)
      e.confirm = 'Les mots de passe ne correspondent pas';
    if (!form.terms)
      e.terms = 'Vous devez accepter les conditions';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* ── Submit ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitError('');
    setSubmitting(true);
    try {
      await register({
        username: form.username.trim(),
        email:    form.email.trim(),
        password: form.password,
        phone_number: `${selectedCountry.dial}${form.phone.trim()}`,
        ...(form.referralCode.trim() ? { referral_code: form.referralCode.trim() } : {}),
      });
      await login(form.email.trim(), form.password);
      navigate('/');
    } catch (err) {
      // Extract the detail part after "NNN — " to show the real server message
      const raw = err?.message ?? '';
      const match = raw.match(/^\d{3}\s*[—-]\s*(.+)$/s);
      const detail = match ? match[1] : raw;
      setSubmitError(detail || "Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rp-root">

      {/* ═══════════ LEFT: FORM ═══════════ */}
      <div className="rp-left">
        <div className="rp-form-card">

          {/* Logo */}
          <Link to="/" className="rp-logo">
            <span className="rp-logo-bolt">⚡</span>
            <span className="rp-logo-text">Afri<span className="rp-logo-accent">Bet</span></span>
          </Link>

          <div className="rp-header">
            <h2 className="rp-title">Créer votre compte</h2>
            <p className="rp-subtitle">Rejoignez la communauté AfriBet</p>
          </div>

          {/* Google sign-in */}
          {/* <button type="button" className="rp-social-btn rp-google rp-google-full">
            <svg width="18" height="18" viewBox="0 0 18 18">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
              <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
            </svg>
            Continuer avec Google
          </button> */}

          <div className="rp-divider">
            <span /><span className="rp-divider-text">ou avec email</span><span />
          </div>

          <form onSubmit={handleSubmit} noValidate>

            {/* Email */}
            <div className="rp-field-group">
              <label>Adresse email <span className="rp-req">*</span></label>
              <input
                type="email"
                placeholder="jean@email.com"
                value={form.email}
                onChange={e => set('email', e.target.value)}
                className={errors.email ? 'error' : ''}
                autoComplete="email"
              />
              {errors.email && <p className="rp-error">{errors.email}</p>}
            </div>

            {/* Username */}
            <div className="rp-field-group">
              <label>Nom d'utilisateur <span className="rp-req">*</span></label>
              <input
                type="text"
                placeholder="ex: jackpot_pro"
                value={form.username}
                onChange={e => set('username', e.target.value)}
                className={errors.username ? 'error' : ''}
                autoComplete="username"
              />
              {errors.username && <p className="rp-error">{errors.username}</p>}
            </div>

            {/* Phone */}
            <div className="rp-field-group">
              <label>Numéro de téléphone <span className="rp-req">*</span></label>
              <div className="rp-phone-wrap">
                <div
                  className="rp-country-selector"
                  onClick={() => setCountryOpen(!countryOpen)}
                >
                  <FlagImg code={selectedCountry.code} />
                  <span>{selectedCountry.dial}</span>
                  <span className="rp-caret">▾</span>
                </div>
                {countryOpen && (
                  <div className="rp-country-dropdown">
                    <div className="rp-country-search-wrap">
                      <input
                        type="text"
                        className="rp-country-search"
                        placeholder="Rechercher..."
                        value={countrySearch}
                        onChange={e => setCountrySearch(e.target.value)}
                        onClick={e => e.stopPropagation()}
                        autoFocus
                      />
                    </div>
                    {COUNTRIES
                      .filter(c =>
                        c.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
                        c.dial.includes(countrySearch)
                      )
                      .map(c => (
                      <div
                        key={c.code}
                        className={`rp-country-option ${c.code === form.country ? 'selected' : ''}`}
                        onClick={() => { set('country', c.code); setCountryOpen(false); setCountrySearch(''); }}
                      >
                        <FlagImg code={c.code} />
                        <span>{c.name}</span>
                        <span className="rp-country-dial">{c.dial}</span>
                      </div>
                    ))}
                  </div>
                )}
                <input
                  type="tel"
                  placeholder="07 12 34 56 78"
                  value={form.phone}
                  onChange={e => set('phone', e.target.value)}
                  className={errors.phone ? 'error' : ''}
                  autoComplete="tel"
                />
              </div>
              {errors.phone && <p className="rp-error">{errors.phone}</p>}
            </div>

            {/* Password */}
            <div className="rp-field-group">
              <label>Mot de passe <span className="rp-req">*</span></label>
              <div className="rp-pw-wrap">
                <input
                  type={showPw ? 'text' : 'password'}
                  placeholder="Minimum 8 caractères"
                  value={form.password}
                  onChange={e => set('password', e.target.value)}
                  className={errors.password ? 'error' : ''}
                  autoComplete="new-password"
                />
                <button type="button" className="rp-pw-toggle" onClick={() => setShowPw(!showPw)}>
                  {showPw ? '🙈' : '👁️'}
                </button>
              </div>
              {form.password && (
                <div className="rp-strength">
                  <div className="rp-strength-bars">
                    {[1,2,3,4].map(n => (
                      <div key={n} className="rp-strength-bar"
                        style={{ background: n <= pwStrength ? strengthColors[pwStrength] : 'var(--border)' }} />
                    ))}
                  </div>
                  <span className="rp-strength-label" style={{ color: strengthColors[pwStrength] }}>
                    {strengthLabels[pwStrength]}
                  </span>
                </div>
              )}
              {errors.password && <p className="rp-error">{errors.password}</p>}
            </div>

            {/* Confirm password */}
            <div className="rp-field-group">
              <label>Confirmer le mot de passe <span className="rp-req">*</span></label>
              <div className="rp-pw-wrap">
                <input
                  type={showConfirm ? 'text' : 'password'}
                  placeholder="Retapez votre mot de passe"
                  value={form.confirm}
                  onChange={e => set('confirm', e.target.value)}
                  className={
                    errors.confirm ? 'error'
                    : form.confirm && form.confirm === form.password ? 'valid'
                    : ''
                  }
                  autoComplete="new-password"
                />
                <button type="button" className="rp-pw-toggle" onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? '🙈' : '👁️'}
                </button>
              </div>
              {form.confirm && form.confirm === form.password && (
                <p className="rp-valid">✓ Les mots de passe correspondent</p>
              )}
              {errors.confirm && <p className="rp-error">{errors.confirm}</p>}
            </div>

            {/* Referral code — optional */}
            <div className="rp-field-group">
              <label>
                Code de parrainage
                <span className="rp-optional"> · optionnel</span>
                {refCode && <span className="rp-badge-ref">Pré-rempli</span>}
              </label>
              <input
                type="text"
                placeholder="BET-XXXXXXXX"
                value={form.referralCode}
                onChange={e => set('referralCode', e.target.value.toUpperCase())}
                readOnly={!!refCode}
                className={refCode ? 'rp-input-readonly' : ''}
              />
              {refCode && (
                <p className="rp-hint-green">✓ Vous avez été invité par un membre AfriBet.</p>
              )}
            </div>

            {/* Terms */}
            <label className={`rp-checkbox ${errors.terms ? 'error' : ''}`}>
              <input type="checkbox" checked={form.terms} onChange={e => set('terms', e.target.checked)} />
              <span className="rp-checkbox-mark" />
              <span>J'accepte les <a href="#terms">CGU</a> et la <a href="#privacy">politique de confidentialité</a>. 18+</span>
            </label>
            {errors.terms && <p className="rp-error">{errors.terms}</p>}

            {/* Submit error */}
            {submitError && (
              <p className="rp-error rp-submit-error">{submitError}</p>
            )}

            {/* Submit */}
            <div className="rp-nav">
              <button type="submit" className="rp-next" disabled={submitting}>
                {submitting ? 'Création en cours...' : <>Continuer <span className="rp-arrow">→</span></>}
              </button>
            </div>

          </form>

          <p className="rp-login-link">
            Déjà inscrit ? <Link to="/login">Se connecter</Link>
          </p>

        </div>
      </div>

      {/* ═══════════ RIGHT PANEL ═══════════ */}
      <div className="rp-right">
        <div className="rp-right-gradient" />

        <div className="rp-balls">
          <span className="rp-ball rp-ball-1">🏆</span>
          <span className="rp-ball rp-ball-2">⚽</span>
          <span className="rp-ball rp-ball-3">🎾</span>
          <span className="rp-ball rp-ball-4">🏀</span>
        </div>

        <div className="rp-right-content">
          <div className="rp-right-hero">
            <h1 className="rp-right-headline">
              REJOIGNEZ<br />
              <span className="rp-right-accent">180 000+</span><br />
              PARIEURS
            </h1>
            <p className="rp-right-sub">La plateforme la plus premium pour vos paris sportifs.</p>
          </div>

          <div className="rp-right-bonus">
            <div className="rp-right-bonus-glow" />
            <div className="rp-right-bonus-inner">
              <div className="rp-right-bonus-icon">🎁</div>
              <div>
                <p className="rp-right-bonus-label">BONUS DE BIENVENUE</p>
                <p className="rp-right-bonus-amount">200 FC</p>
                <p className="rp-right-bonus-sub">100% sur votre 1er dépôt</p>
              </div>
            </div>
          </div>

          <div className="rp-right-features">
            {[
              { icon: '⚽', text: '10 000+ matchs par mois' },
              { icon: '📊', text: 'Cotes en temps réel' },
              { icon: '💳', text: 'Retraits en 24h' },
              { icon: '🔒', text: 'Plateforme 100% sécurisée' },
            ].map(f => (
              <div key={f.text} className="rp-right-feature">
                <span className="rp-right-feature-icon">{f.icon}</span>
                <span>{f.text}</span>
              </div>
            ))}
          </div>

          <div className="rp-right-social-proof">
            <div className="rp-proof-avatars">
              {['A', 'B', 'C', 'D'].map((l, i) => (
                <div key={l} className="rp-proof-avatar"
                  style={{ zIndex: 4 - i, marginLeft: i > 0 ? -10 : 0 }}>{l}</div>
              ))}
            </div>
            <p className="rp-proof-text">+1 200 inscrits cette semaine</p>
          </div>
        </div>
      </div>

    </div>
  );
}
